import React, { useEffect, useState, useRef } from 'react';
import './Testimonials.css';

const testimonials = [
  {
    quote:
      'Steuer- und Wirtschaftsberater meines Vertrauens! Bereits seit mehreren Jahren, super zufrieden mit der umfassenden Beratung in allen strategischen, steuerlichen und wirtschaftlichen Themen unserer Unternehmungen!',
    author: 'Ilja Jay',
    org: 'FOLLOW Austria',
    website: 'https://www.followaustria.com/',
    avatar: '/img/ilja.png',
  },
  {
    quote:
      'Wir arbeiten seit geraumer Zeit mit Nintschew & Partner zusammen und sind mit der Betreuung sehr zufrieden. Als Unternehmensgruppe mit verschiedenen Gesellschaften schätzen wir besonders die strukturierte und zuverlässige Arbeitsweise des Teams. Unsere Anliegen werden immer schnell bearbeitet und auch komplexe Sachverhalte verständlich erklärt. Die Zusammenarbeit ist professionell, lösungsorientiert und geprägt von einem klaren Blick für wirtschaftliche Zusammenhänge. Rückfragen werden kompetent beantwortet, und wir fühlen uns bei steuerlichen wie auch betriebswirtschaftlichen Themen gut begleitet. Für uns ist Nintschew & Partner ein verlässlicher Partner, den wir uneingeschränkt weiterempfehlen können.',
    author: 'Mehmet Altuntop',
    org: 'Top Assets Group',
    website: 'https://www.topassetsgroup.com/',
    avatar: '/img/Mehmet_Altuntop.jpg',
  },
  {
    quote:
      'Ich bin seit 2017 selbständig und hatte bereits Erfahrungen mit 4 Steuerberatern. Andrei Nintschew ist mit Abstand zu unserer größten Vertrauensperson geworden und ein treibender, entscheidender Faktor in unserem Firmenwachstum. Was es für mich unersetzlich macht ist die gute Erreichbarkeit, schnelle Hilfe und die proaktive Wirtschaftsberatung, die weit über reguläre Steuerberatung hinausgeht.',
    author: 'Pedram Parsaian',
    org: 'FOLLOW Austria',
    website: 'https://www.followaustria.com/',
    avatar: '/img/pedram.png',
  },
  {
    quote:
      'Die Zusammenarbeit mit Andrei und seinem Team funktioniert hervorragend. Man bekommt zu jeder Frage eine kompetente Antwort und es werden auch pro aktiv Optimierungsmöglichkeiten angesprochen. Eine große Empfehlung meinerseits!',
    author: 'Daniel Peer',
    org: 'DPengineering',
    website: 'https://dpengineering.at/',
    avatar: '/img/Daniel_Peer.jpg',
  },
  {
    quote:
      'Ich bin mit mehreren Firmen seit Jahren Kunde bei Nintschew & Partner – und rundum zufrieden. Besonders beeindruckt mich Andrei Nintschew selbst: Er denkt nicht nur an die nächste Steuererklärung, sondern plant immer strategisch und langfristig. Er erkennt schnell, worauf es im Unternehmen ankommt, und findet klare, durchdachte Lösungen, die steuerlich und wirtschaftlich Sinn machen. Dabei ist er immer persönlich ansprechbar, engagiert und nimmt sich Zeit. Gerade bei größeren Entscheidungen wie Umstrukturierungen oder Firmenveränderungen ist seine Erfahrung und sein Blick fürs Ganze ein echter Vorteil. Fazit: Wer mehr will als nur Buchhaltung, ist hier genau richtig. Andrei Nintschew bietet smarte Steuerberatung mit Strategie – und das auf hohem Niveau. Absolute Empfehlung!',
    author: 'Michael Kececi',
    org: 'Immobilieninvestor',
    avatar: '/img/Michael_Kececi.jpg',
  },
  {
    quote:
      'Herr Nintschew und sein Team betreuen uns bereits seit Gründung der Kanzlei – und ich kann nur sagen: Hier wird man nicht nur betreut, sondern wirklich beraten. Während andere Kanzleien oft nur die Steuererklärung einreichen oder einen Jahresabschluss erstellen, denkt Herr Nintschew mit – vorausschauend und strategisch. Ob es um strukturelle Planung oder um allgemeine Tipps geht – diese Kanzlei ist eine Empfehlung für jeden Unternehmer, insbesondere auch für Jungunternehmer.',
    author: 'Marc Crane',
    org: 'Daro GmbH',
    website: 'https://www.daro.co.at/',
    avatar: '/img/Marc_Crane.jpg',
  },
  {
    quote:
      'Seit Jahren arbeite ich eng mit Nintschew & Partner zusammen – insbesondere bei Umgründungen und komplexen immobiliensteuerrechtlichen Fragestellungen. Herr Nintschew ist ein Fachmann und Stratege, der mit Weitblick und Präzision überzeugt. Eine Zusammenarbeit auf höchstem Niveau, die ich uneingeschränkt empfehlen kann.',
    author: 'Philip Fabry',
    org: 'Eckert Fries Carter Rechtsanwälte',
    website: 'https://www.efpr.at/',
    avatar: '/img/eckert.jpg',
  },
];

const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const intervalRef = useRef(null);

  const next = () => setIndex((i) => (i + 1) % testimonials.length);
  const prev = () => setIndex((i) => (i - 1 + testimonials.length) % testimonials.length);

  // Auto-rotate deaktiviert - nur manueller Wechsel durch Klicks
  // useEffect(() => {
  //   intervalRef.current = setInterval(next, 6000);
  //   return () => clearInterval(intervalRef.current);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // Pause auto-rotate while user hovers or interacts
  // const pause = () => intervalRef.current && clearInterval(intervalRef.current);
  // const resume = () => (intervalRef.current = setInterval(next, 6000));

  const current = testimonials[index];

  return (
    <section className="testimonials" id="testimonials">
      <div className="testimonials__inner">
        <div className="testimonials__header">
          <div className="testimonials__eyebrow">REFERENZEN</div>
          <div className="testimonials__title-container">
            <svg className="testimonials__quote-bg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="m4.7 17.7c-1-1.1-1.6-2.3-1.6-4.3 0-3.5 2.5-6.6 6-8.2l.9 1.3c-3.3 1.8-4 4.1-4.2 5.6.5-.3 1.2-.4 1.9-.3 1.8.2 3.2 1.6 3.2 3.5 0 .9-.4 1.8-1 2.5-.7.7-1.5 1-2.5 1-1.1 0-2.1-.5-2.7-1.1zm10 0c-1-1.1-1.6-2.3-1.6-4.3 0-3.5 2.5-6.6 6-8.2l.9 1.3c-3.3 1.8-4 4.1-4.2 5.6.5-.3 1.2-.4 1.9-.3 1.8.2 3.2 1.6 3.2 3.5 0 .9-.4 1.8-1 2.5s-1.5 1-2.5 1c-1.1 0-2.1-.5-2.7-1.1z"/>
            </svg>
            <h2 className="testimonials__title">Was unsere Mandanten und Partner über uns sagen</h2>
          </div>
        </div>

        <div className="testimonials__slider">
          <div className="testimonials__badges">
            {current.avatar && (
              <div className="testimonials__avatar" aria-hidden>
                <img src={current.avatar} alt="" />
              </div>
            )}
          </div>
          <button className="testimonials__nav testimonials__nav--prev" aria-label="Previous" onClick={prev}>
            <img src="/img/down.svg" alt="" className="testimonials__nav-icon testimonials__nav-icon--prev" />
          </button>

          <figure key={index} className="testimonials__item">
            <blockquote className="testimonials__quote">
              "{current.quote}"
            </blockquote>
            <figcaption className="testimonials__author">
              <div className="testimonials__author-info">
                <div className="testimonials__author-details">
                  <span className="testimonials__author-name">{current.author}</span>
                  <span className="testimonials__separator">•</span>
                  <span className="testimonials__author-org">{current.org}</span>
                  {current.website && (
                    <>
                      <span className="testimonials__separator">•</span>
                      <a href={current.website} target="_blank" rel="noopener noreferrer" className="testimonials__website">
                        {current.website.replace('https://www.', '').replace('https://', '').replace('/', '')}
                      </a>
                    </>
                  )}
                </div>
              </div>

            </figcaption>
          </figure>

          <button className="testimonials__nav testimonials__nav--next" aria-label="Next" onClick={next}>
            <img src="/img/down.svg" alt="" className="testimonials__nav-icon testimonials__nav-icon--next" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;


